import { i18nBuilder } from "keycloakify/login";
import type { ThemeName } from "../kc.gen";

/** @see: https://docs.keycloakify.dev/i18n */
// cspell: disable
const { useI18n, ofTypeI18n } = i18nBuilder
    .withThemeName<ThemeName>()
    .withExtraLanguages({
        vn: {
            label: "Tiếng Việt",
            getMessages: () => import("./i18n/vn")
        },
        ko: {
            label: "한국어",
            getMessages: () => import("./i18n/ko")
        }
    })
    .withCustomTranslations({
        // cspell: disable
        en: {
            accountDisabledMessage: "Account is disabled, contact your Account Service Manager",
            acceptClientAgreement: "I agree with {{0}}",
            clientAgreement: "Client Agreement",
            alreadyHaveAccount: "Already have an account?",
            signIn: "Sign In",
            notRegisteredYet: "Not registered yet?",
            signUp: "SIGN UP"
        },
        es: {
            accountDisabledMessage: "La cuenta está deshabilitada, comuníquese con su Gerente de Servicio de Cuenta.",
            acceptClientAgreement: "Estoy de acuerdo con {{0}}",
            clientAgreement: "Acuerdo de cliente",
            alreadyHaveAccount: "¿No tienes una cuenta?",
            signIn: "Iniciar Sesión",
            notRegisteredYet: "¿Ya tienes una cuenta?",
            signUp: "REGÍSTRATE"
        },
        fa: {
            accountDisabledMessage: "حساب کاربری غیرفعال است، با مدیر خدمات حساب خود تماس بگیرید.",
            acceptClientAgreement: "من موافقم با {{0}}",
            clientAgreement: "قرارداد مشتری",
            alreadyHaveAccount: "حساب ندارید؟",
            signIn: "ورود",
            notRegisteredYet: "قبلاً حساب دارید؟",
            signUp: "ثبت نام"
        },
        fr: {
            accountDisabledMessage: "Le compte est désactivé, contactez votre responsable de compte.",
            acceptClientAgreement: "J'accepte {{0}}",
            clientAgreement: "Accord client",
            alreadyHaveAccount: "Vous n'avez pas de compte?",
            signIn: "Se connecter",
            notRegisteredYet: "Vous avez déjà un compte?",
            signUp: "S'INSCRIRE"
        },
        ja: {
            accountDisabledMessage: "アカウントが無効になっています。アカウント サービス マネージャーに問い合わせてください。",
            acceptClientAgreement: "次の文書に同意します： {{0}}",
            clientAgreement: "「顧客契約」",
            alreadyHaveAccount: "アカウントをお持ちではありませんか？",
            signIn: "サインイン",
            notRegisteredYet: "アカウントを既にお持ちですか？",
            signUp: "サインアップ"
        },
        ko: {
            accountDisabledMessage: "계정이 비활성화되었습니다. 계정 서비스 관리자에게 문의하세요.",
            acceptClientAgreement: "본인은 {{0}}",
            clientAgreement: "고객 동의서를 수락합니다",
            alreadyHaveAccount: "계좌가 없으신가요?",
            signIn: "로그인",
            notRegisteredYet: "이미 계좌가 있으신가요?",
            signUp: "등록하기"
        },
        pt: {
            accountDisabledMessage: "A conta está desativada, contacte o seu gestor de serviços de conta.",
            acceptClientAgreement: "Eu concordo com {{0}}",
            clientAgreement: "Acordo de Cliente",
            alreadyHaveAccount: "Não tem conta?",
            signIn: "ASSINAR EM",
            notRegisteredYet: "Já tem uma conta?",
            signUp: "INSCREVER-SE"
        },
        th: {
            accountDisabledMessage: "บัญชีถูกปิดใช้งาน โปรดติดต่อผู้จัดการบริการบัญชีของคุณ",
            acceptClientAgreement: "ฉันเห็นด้วยกับ {{0}}",
            clientAgreement: "ข้อตกลงของลูกค้า",
            alreadyHaveAccount: "ยังไม่มีบัญชี?",
            signIn: "เข้าสู่ระบบ",
            notRegisteredYet: "มีบัญชีอยู่แล้ว?",
            signUp: "ลงชื่อ"
        },
        vn: {
            accountDisabledMessage: "Tài khoản đã bị vô hiệu hóa, hãy liên hệ với Người quản lý dịch vụ tài khoản của bạn",
            acceptClientAgreement: "Tôi đồng ý với {{0}}",
            clientAgreement: "Thoả thuận Khách hàng",
            alreadyHaveAccount: "Không có tài khoản?",
            signIn: "ĐĂNG NHẬP",
            notRegisteredYet: "Bạn co săn san để tạo một tai khoản?",
            signUp: "ĐĂNG KÝ"
        },
        "zh-CN": {
            accountDisabledMessage: "账户已经关闭，请联系管理员",
            acceptClientAgreement: "我同意 {{0}}",
            clientAgreement: "客户协议",
            alreadyHaveAccount: "还没有账户？",
            signIn: "登记",
            notRegisteredYet: "已经有账户？",
            signUp: "注册登记"
        }
        // cspell: enable
    })
    .build();

type I18n = typeof ofTypeI18n;

export { useI18n, type I18n };
